module.exports = __webpack_public_path__ + "static/media/JP_RC_EYELASHES04.26c5e763.jpg";